import { render, staticRenderFns } from "./payForDetails.vue?vue&type=template&id=53f4cec1&scoped=true"
import script from "./payForDetails.vue?vue&type=script&lang=js"
export * from "./payForDetails.vue?vue&type=script&lang=js"
import style0 from "./payForDetails.vue?vue&type=style&index=0&id=53f4cec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f4cec1",
  null
  
)

export default component.exports